import React from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogBody, DialogFooter,
  Button, Textarea,
} from '@parsina/framework';

import { useTranslation } from '../../i18n/I18nProvider.jsx';

// «شروع ویزیت» — one field, because there is only one thing to decide.
//
// «علت مراجعه» is pre-filled from the chief complaint, which is right most of
// the time and wrong in the one case that matters: a patient who was built
// around chest pain and is being seen today about their diabetes. A dialog with
// a pre-filled, editable line costs one Enter when the default is right and
// saves the visit's whole framing when it is not.
//
// It is deliberately NOT a confirmation. Starting a visit writes a row, and the
// student can cancel it («لغو ویزیت», core.md §6) — so the dialog asks for the
// one input the mutation takes and nothing else.

export default function StartVisitDialog({ open, onClose, reason, onReason, onSubmit, saving }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
      <DialogContent size="sm" data-testid="start-visit-dialog">
        <DialogHeader>
          <DialogTitle>{t('record.startVisit.title')}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Textarea
            label={t('record.startVisit.reason')}
            helperText={t('record.startVisit.reasonHelper')}
            value={reason}
            onChange={(e) => onReason(e.target.value)}
            rows={3}
            maxLength={500}
            disabled={saving}
            autoFocus
            data-testid="start-visit-reason"
          />
        </DialogBody>
        <DialogFooter style={{ display: 'flex', gap: 8, marginTop: 16 }}>
          <Button onClick={onSubmit} disabled={saving} data-testid="start-visit-submit">
            {saving ? t('common.actions.saving') : t('record.startVisit.submit')}
          </Button>
          <Button variant="outline" onClick={onClose} disabled={saving}>
            {t('common.actions.cancel')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
